import Cookies from 'js-cookie'
import numeral from 'numeral'
import moment from 'moment'
import qs from 'qs'
// eslint-disable-next-line import/no-cycle
import * as gloalAPI from '@/api/global'
import {
  getTenantId,
} from '@/utils/auth'
import * as loginApi from '@/api/login'

export const safeStringify = (obj) => {
  const getCircularReplacer = () => {
    const seen = new WeakSet()
    return (key, value) => {
      if (typeof value === 'object' && value !== null) {
        if (seen.has(value)) {
          return '[Circular]'
        }
        seen.add(value)
      }
      return value
    }
  }

  try {
    return JSON.stringify(obj, getCircularReplacer())
  } catch (error) {
    return '[Stringify Error]'
  }
}

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((String(time)).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    if ((result.length > 0) && (value < 10)) {
      value = `0${value}`
    }
    return value || 0
  })
  return time_str
}

export function formatTime(time, option) {
  time = Number(time) * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return `${Math.ceil(diff / 60)}分钟前`
  } else if (diff < 3600 * 24) {
    return `${Math.ceil(diff / 3600)}小时前`
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      `${d.getMonth() +
      1
      }月${d.getDate()
      }日${d.getHours()
      }时${d.getMinutes()
      }分`
    )
  }
}

export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}


export function formatDate(toFormat, format = 'YYYY-MM-DD') {
  return moment(toFormat).format(format)
}

// 函数节流
export function throttle(func, threshhold = 160, immediate) {
  let timeout
  let start = new Date()

  return function () {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const context = this
    const args = arguments
    const curr = new Date() - 0

    clearTimeout(timeout)
    if (curr - start >= threshhold) {
      func.apply(context, args)
      start = curr
    } else if (immediate) {
      timeout = setTimeout(() => {
        func.apply(context, args)
      }, threshhold)
    }
  }
}
// 函数防抖
export function debounce(func, delay = 160) {
  let timeout
  return function () {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const context = this
    const args = arguments

    clearTimeout(timeout)
    timeout = setTimeout(() => {
      func.apply(context, args)
    }, delay)
  }
}
// 连续触发，在某一段时间只触发第一个函数，之后触发第二个函数
export function carryFirst(func, func2, delay = 10000) {
  let timeout
  let total = 0
  return function () {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const context = this
    const args = arguments
    if (total === 0) {
      func && func.apply(context, args)
    } else {
      func2 && func2.apply(context, args)
    }
    ++total
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      total = 0
    }, delay)
  }
}

// 后台埋点日志收容
export function logEvent(router) {
  if (router.meta.logEvent) {
    const data = {
      version: '1.0',
      pid: 'admin',
      page: router.meta.logEvent,
      click: `${router.meta.logEvent}_Show`,
    }
    gloalAPI.logTakeIn(data)
  }
}

// 通过组件名称组件实例
export function findComponentByName(context, componentName) {
  let component = null
  function callback($) {
    $.$children.forEach((i) => {
      if (i.$options.name === componentName) {
        component = i
        return
      }
      if (i.$children) {
        callback(i, componentName)
      }
    })
  }
  callback(context, componentName)
  return component
}

/**
 * randomWord 产生任意长度随机字母数字组合
 * @param randomFlag 是否任意长度 min-任意长度最小位[固定位数] max-任意长度最大位
 * @param min
 * @param max
 * @returns {string}
 */
export function randomWord(randomFlag, min, max) {
  let str = ''
  let range = min
  const arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']

  // 随机产生
  if (randomFlag) {
    range = Math.round(Math.random() * (max - min)) + min
  }
  for (let i = 0; i < range; i++) {
    const pos = Math.round(Math.random() * (arr.length - 1))
    str += arr[pos]
  }
  return str
}

export function repeatContent(obj = {}) {
  const { messageVariable = [], content } = Object.assign({}, obj)
  let str = content
  let messageVariableArr = []
  try {
    messageVariableArr = JSON.parse(messageVariable) || []
  } catch (e) {
    messageVariableArr = messageVariable
    if (messageVariable === '') {
      messageVariableArr = []
    }
  }
  messageVariableArr.forEach((val) => {
    str = str.replace(val.regex, val.value)
  })
  return str
}
// 时间校验几点到几点time_range(9:00,17:00)精确到分
export function timeRange(beginTime, endTime, sendTime) {
  const strb = beginTime.split(':')
  if (strb.length !== 2) {
    return false
  }
  const stre = endTime.split(':')
  if (stre.length !== 2) {
    return false
  }
  const b = new Date(sendTime)
  const e = new Date(sendTime)
  const n = new Date(sendTime)

  b.setHours(strb[0])
  b.setMinutes(strb[1])
  e.setHours(stre[0])
  e.setMinutes(stre[1])
  if ((n.getTime() - b.getTime() > 0) && (n.getTime() - e.getTime() < 0)) {
    return true
  } else {
    return false
  }
}
// 精确到分
export function time_range(beginTime, endTime) {
  const strb = beginTime.split(':')
  if (strb.length !== 2) {
    return false
  }
  const stre = endTime.split(':')
  if (stre.length !== 2) {
    return false
  }
  const b = new Date()
  const e = new Date()
  const n = new Date()
  b.setHours(strb[0])
  b.setMinutes(strb[1])
  e.setHours(stre[0])
  e.setMinutes(stre[1])
  if ((n.getTime() - b.getTime() > 0) && (n.getTime() - e.getTime() < 0)) {
    return true
  } else {
    return false
  }
}
// 精确到秒
export function time_range_Seconds(beginTime, endTime, data) {
  const strb = beginTime.split(':')
  const stre = endTime.split(':')
  const b = new Date(data)
  const e = new Date(data)
  const n = new Date(data)
  b.setHours(strb[0])
  b.setMinutes(strb[1])
  b.setSeconds(strb[2])
  e.setHours(stre[0])
  e.setMinutes(stre[1])
  e.setSeconds(stre[2])
  if ((n.getTime() - b.getTime() > 0) && (n.getTime() - e.getTime() < 0)) {
    return true
  } else {
    return false
  }
}
export function getBrandName(row = {}, brandList = []) {
  return (brandList.filter((v) => v.tenantId === row.tenantId)[0] || {}).tenantName || ''
}
// 寻找数组最接近某个值
export const lookup = function (array, value) {
  if (array.length === 1) {
    return array[0]
  }
  // 将原数组复制，不会影响原数组
  const arr = array.concat([])
  arr.push(value)
  // 数据排序
  arr.sort((a, b) => {
    return a - b
  })
  const index = arr.indexOf(value)
  // 当前项在数组第一项 / 最后一项，返回当前项的后一项 / 前一项
  if (index === 0) {
    return arr[index + 1]
  } else if (index === arr.length - 1) {
    return arr[index - 1]
  }
  // 当前项和前一项或者后一项比较，返回差值小的项
  const resultIndex =
    arr[index] - arr[index - 1] >= arr[index + 1] - arr[index]
      ? index + 1
      : index - 1
  return arr[resultIndex]
}

export const downFileByUrl = (videoSrc, fileName) => {
  const name = fileName || videoSrc.split('/')[videoSrc.split('/').length - 1]
  const x = new XMLHttpRequest()
  x.open('GET', videoSrc, true)
  x.responseType = 'blob'
  x.onload = function () {
    const url = window.URL.createObjectURL(x.response)
    const a = document.createElement('a')
    a.href = url
    a.download = name
    a.click()
  }
  x.send()
}

// 后台埋点日志收容
export function logBuryPoint(page, click) {
  if (!page && !click) return
  const data = {
    page,
    click,
  }
  gloalAPI.logTakeIn(data)
}

function getBreadCrumb(to, store) {
  return store.getters.menus[to.name] || []
}

// 设置当前页面面包屑
export const setBreadcrumb = (route, store, needHome = true, needCur = true) => {
  let breadcrumb = getBreadCrumb(route, store)
  // let breadcrumb = (route && route.meta && route.meta.levels) || []
  let subMenu = store.getters.subMenuList
  breadcrumb = breadcrumb.reduce((pre, item, ind) => {
    if (ind === 0) {
      const one = store.getters.addRouters.find((r) => r.name === item)
      if (one) {
        pre.push({
          ...one,
          name: (one.meta.resourceName || one.meta.title),
        })
      }
      return pre
    }
    subMenu = (subMenu && subMenu.find((menu) => menu.resourceKey === item)) || null
    if (subMenu) {
      const result = {
        // eslint-disable-next-line no-nested-ternary
        path: (subMenu && subMenu.redirect && subMenu.redirect !== 'noredirect')
          ? subMenu.redirect
          : (subMenu && (subMenu.resourceType === 1)) ? subMenu.path : null,
        name: subMenu.resourceName || item.resourceName || (item.meta && item.meta.title) || '',
      }
      pre.push(result)
    }
    subMenu = (subMenu && subMenu.children) || []
    return pre
  }, [])
  if (needHome) {
    breadcrumb.unshift({
      name: '首页',
      path: '/',
    })
  }
  if (needCur) {
    breadcrumb.push({
      name: route.meta.resourceName || route.meta.title,
      path: null,
    })
  }
  store.commit('SET_BREADCRUMB', breadcrumb)
}

function getLastDate(y, m) {
  return Number(moment(`${y}/${m}/01`).endOf('month').format('DD'))
}

export const getWeeks = (start, end) => {
  let startTime = new Date(start)
  const endTime = new Date(end)
  const result = []
  while (startTime <= endTime) {
    // 判断是否超过合同结束时间   超过合同结束时间 周期结束时间就取合同结束时间
    if (moment(startTime).add(6, 'days').isAfter(endTime)) {
      result.push({
        start: moment(startTime).format('YYYY-MM-DD'),
        end: moment(endTime).format('YYYY-MM-DD'),
      })
    } else {
      result.push({
        start: moment(startTime).format('YYYY-MM-DD'),
        end: moment(startTime).add(6, 'days').format('YYYY-MM-DD'),
      })
    }
    startTime = moment(startTime).add(7, 'days').format('YYYY-MM-DD')
    startTime = new Date(startTime)
  }

  return result
}

export const getStage = (start, end, date) => {
  let now = new Date(start)
  const endTime = new Date(end)
  const result = []
  while (now < endTime) {
    let y = now.getFullYear()
    let m = now.getMonth() + 1
    const d = now.getDate()

    let startDate = !result.length ? `${y}/${m}/${d}` : moment(`${y}/${m}/${d}`).add(1, 'days').format('YYYY-MM-DD')
    startDate = moment(startDate).format('YYYY-MM-DD')

    let endDate
    if (!(!result.length && (d <= date))) {
      if (m === 12) {
        y += 1
        m = 1
      } else {
        m += 1
      }
    }
    const lastDate = getLastDate(y, m)
    const endDay = Math.min(date, lastDate)
    endDate = `${y}-${m < 10 ? `0${m}` : m}-${endDay < 10 ? `0${endDay}` : endDay}`
    if (new Date(end) > endTime) {
      endDate = moment(endTime).format('YYYY-MM-DD')
    }
    endDate = moment(end).format('YYYY-MM-DD')
    result.push({
      start: startDate,
      end: endDate,
    })
    now = new Date(end)
    continue
  }
  return result
}

export const updateHead = (store) => {
  Cookies.set('_admin_tk', store.getters.token)
  Cookies.set('_admin_ts', moment().unix())
  Cookies.set('_admin_eid', getTenantId())
}

export const getHead = (store) => {
  return {
    _admin_tk: store.getters.token,
    _admin_ts: moment().unix(),
    _admin_eid: getTenantId(),
  }
}

// 判断日期添加长期文案
// 日期大于2099年的判断为长期
export const addLongTermText = (str) => {
  if (str) {
    if (moment(str).valueOf() >= moment('2099-01-01').valueOf()) {
      return '长期有效'
    }
  }
  return str
}

// 资源数据平铺
export const flatFun = (arg = []) => {
  const newArr = []
  function recursion(data) {
    data.forEach((item) => {
      const obj = JSON.parse(JSON.stringify(item))
      delete obj.subList
      newArr.push(obj)
      item.subList && recursion(item.subList)
    })
    return newArr
  }
  recursion(arg)
  return newArr
}

// 时间格式校验-主要针对于ocr识别后的日期是否正确
export const verifyFun = (data = '') => {
  let result = ''
  try {
    result = moment(data).format('YYYY-MM-DD')
  } catch (error) {
    console.error(error)
    result = 'Invalid date'
  }
  return result
}

export function getOS() {
  const { userAgent } = window.navigator
  const { platform } = window.navigator
  const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K']
  const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE']
  const iosPlatforms = ['iPhone', 'iPad', 'iPod']
  let os = null

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = 'Mac OS'
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = 'iOS'
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = 'Windows'
  } else if (/Android/.test(userAgent)) {
    os = 'Android'
  } else if (!os && /Linux/.test(platform)) {
    os = 'Linux'
  }
  return os
}


export function browser_type() {
  const explorer = navigator.userAgent
  if (explorer.indexOf('MSIE') >= 0) {
    return 'ie'
  } else if (explorer.indexOf('Maxthon') >= 0) {
    return 'Maxthon' // 遨游
  } else if (explorer.indexOf('Firefox') >= 0) {
    return 'Firefox'
  } else if (explorer.indexOf('OPR') >= 0) {
    return 'Opera'
  } else if (explorer.indexOf('Netscape') >= 0) {
    return 'Netscape'
  } else if (explorer.indexOf('Edg') >= 0) {
    return 'Edge'
  } else if (explorer.indexOf('Chrome') >= 0) {
    return 'Chrome'
  } else if (explorer.indexOf('Safari') >= 0) {
    return 'Safari'
  }
}
// 获取base-list-management、base-form、base-table、search-form最终的ref
export const getRefs = function ({ baseListManagementRef, searchFormRef, baseFormRef, formRef, formItemRef, type = 'form', baseTableRef, commonTableRef }) {
  // baseListManagementRef：使用通用模版对应的ref；searchFormRef：独立使用search-form组件对应的ref；baseFormRef：独立使用base-form组件对应的ref；formRef：通过formData/formProps传入的ref；formItemRef：通过formData/list/itemConfig传入的ref；type：包含form和table两种，根据使用的组件决定，base-table组件用table，使用跟form相关的组件用form；baseTableRef：使用base-table组件对应的ref，commonTableRef：通过tableData配置信息传入的ref
  // eslint-disable-next-line no-nested-ternary
  const tempRef = type === 'form' ? (baseListManagementRef ? this.$refs[baseListManagementRef].$refs.searchForm.$refs.searchForm : searchFormRef ? this.$refs[searchFormRef].$refs.searchForm : baseFormRef ? this.$refs[baseFormRef] : '') : (baseListManagementRef ? this.$refs[baseListManagementRef].$refs.baseTable : this.$refs[baseTableRef])
  // eslint-disable-next-line no-nested-ternary
  const ref = type === 'form' ? (formRef ? tempRef.$refs[formRef || 'form'] : formItemRef ? tempRef.$refs.baseFormItem.$refs[formItemRef] : tempRef) : (commonTableRef ? tempRef.$refs[commonTableRef] : tempRef)
  return ref
}

// 设置模版数据formData/list/elConfig/list值
export const setItemData = function ({ elConfigKeys = null, elConfigKey = null, key, data }) {
  // key：formData/list/itemConfig/prop值，data：接口数据或是本地维护的数据,elConfigKeys:elConfig的属性；elConfigKey:elConfig属性为对象的对象属性
  const tempList = this.configData.formData.list
  const formItem = tempList && tempList.find((item) => item.itemConfig.prop === key)

  let formItemKey = null
  if (elConfigKeys) {
    formItemKey = formItem.elConfig[elConfigKeys]
  } else if (elConfigKey) {
    formItemKey = formItem.elConfig
  }

  if (formItem && formItemKey) {
    this.$set(formItemKey, elConfigKey, data)
  } else {
    formItem.isShow = data
  }
}

export const numberMap = (num) => {
  const changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
  const unit = ['', '十', '百', '千', '万']
  num = parseInt(num)
  const getWan = (temp) => {
    const strArr = temp.toString().split('').reverse()
    let newNum = ''
    const newArr = []
    strArr.forEach((item, index) => {
      newArr.unshift(item === '0' ? changeNum[item] : changeNum[item] + unit[index])
    })
    const numArr = []
    newArr.forEach((m, n) => {
      if (m !== '零') numArr.push(n)
    })
    if (newArr.length > 1) {
      newArr.forEach((m, n) => {
        if (newArr[newArr.length - 1] === '零') {
          if (n <= numArr[numArr.length - 1]) {
            newNum += m
          }
        } else {
          newNum += m
        }
      })
    } else {
      newNum = newArr[0]
    }

    return newNum
  }
  const overWan = Math.floor(num / 10000)
  let noWan = num % 10000
  if (noWan.toString().length < 4) {
    noWan = `0${noWan}`
  }
  return overWan ? `${getWan(overWan)}万${getWan(noWan)}` : getWan(num)
}

/**
 * 将数字用千分位分割，并保留小数点后几位
 * @param {Number} number 数字
 * @param {Number} decimalPlaces 小数点后位数
 * @returns 格式化后的数字
 */
export function convertNumber(number, decimalPlaces = 2) {
  return (Number(number)).toFixed(decimalPlaces).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
}

// 输入时间2023-07-08 / 1689218200549 是否小于当前时间 以天为基准做比较
export function judgeDayWithNow(date = Date.now(), judgeType) {
  const FORMAT_TYPE = 'YYYYMMDD'
  const left = parseInt(moment(date).format(FORMAT_TYPE))
  const right = parseInt(moment(Date.now()).format(FORMAT_TYPE))
  if (judgeType) {
    return left < right
  }
  return left <= right
}

/**
 * 加法 (入参支持多个数)
*/
export function addition(...numbers) {
  const precision = getMaximumDecimalPlaces(numbers)
  const multiplier = Math.pow(10, precision)

  const result = numbers.reduce((sum, num) => {
    return sum + Number((num * multiplier).toFixed())
  }, 0) / multiplier

  return result
}

function getMaximumDecimalPlaces(numbers) {
  return numbers.reduce((maxPrecision, num) => {
    return Math.max(maxPrecision, getDecimalPlaces(num))
  }, 0)
}

function getDecimalPlaces(number) {
  const match = String(number).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/)
  if (!match) {
    return 0
  }
  return Math.max(
    0,
    // Number of digits right of decimal point.
    (match[1] ? match[1].length : 0) -
    // Adjust for scientific notation.
    (match[2] ? Number(match[2]) : 0),
  )
}
// 数字增加千分符
export function formatNumberWithCommas(number) {
  try {
    number = Number(number)
  } catch (error) {
    return ''
  }
  if (isNaN(number)) {
    return ''
  }
  if (!Number.isFinite(number)) {
    return ''
  }
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

// 复制文本到剪切板
export function copyToClipboard(text, callback) {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text)
  } else {
    const textarea = document.createElement('textarea')
    document.body.appendChild(textarea)
    textarea.style.position = 'fixed'
    textarea.style.clip = 'rect(0 0 0 0)'
    textarea.style.top = '10px'
    textarea.value = text
    textarea.select()
    document.execCommand('copy', true)
    document.body.removeChild(textarea)
  }
  typeof callback === 'function' && callback()
}


// 判断返回的数据是不是json
export function isJSON(str) {
  if (typeof str === 'string') {
    try {
      const obj = JSON.parse(str)
      if (typeof obj === 'object' && obj) {
        return true
      } else {
        return false
      }
    } catch (e) {
      return false
    }
  } else {
    return false
  }
}

/**
 * @apiName (对象)数组去重
 * @params  arr:数组 key:过滤key
 */
export function unique(arr, key) {
  const map = new Map()
  for (const item of arr) {
    if (!map.has(item[key])) {
      map.set(item[key], item)
    }
  }
  return [...map.values()]
}
// 计算相差的月数
export function calculateMonths(endTime, startTime) {
  const durations = moment.duration({ from: moment(startTime), to: moment(endTime) })
  return 12 * durations.years() + durations.months() + 1
}


/**
 * 数字格式化
 * @param a 数字
 * @param b 保留后几位
 * @returns
 */
export function amoutInterval(a, b) {
  const _formatStr = `0,0.${'0'.repeat(b)}`
  return numeral(a).format(_formatStr)
}

// 打开新页面方法
export const openNewPages = (params) => {
  const { query } = params
  const queryStr = query ? qs.stringify(query) : ''
  let href = `${location.origin}${params.path}`
  href = queryStr ? `${href}?${queryStr}` : href
  window.open(href, '_blank')
}

/**
 * flexWidth
 * @param prop 每列的prop 可传''
 * @param tableData 表格数据
 * @param title 标题长内容短的，传标题  可不传
 * @param num 列中有标签等加的富余量
 * @returns 列的宽度
 * 注：prop,title有一个必传
 */
export const flexWidth = (prop, tableData, title, num = 0) => {
  if (tableData.length === 0) { // 表格没数据不做处理
    return ''
  }
  let _flexWidth = 0// 初始化表格列宽
  let columnContent = ''// 占位最宽的内容
  const canvas = document.createElement('canvas')
  const context = canvas.getContext('2d')
  context.font = '14px Microsoft YaHei'
  if ((prop === '') && title) { // 标题长内容少的，取标题的值,
    columnContent = title
  } else { // 获取该列中占位最宽的内容
    let index = 0
    for (let i = 0; i < tableData.length; i++) {
      const now_temp = `${tableData[i][prop]}`
      const max_temp = `${tableData[index][prop]}`
      const now_temp_w = context.measureText(now_temp).width
      const max_temp_w = context.measureText(max_temp).width
      if (now_temp_w > max_temp_w) {
        index = i
      }
    }
    columnContent = tableData[index][prop]
    // 比较占位最宽的值跟标题、标题为空的留出四个位置
    const column_w = context.measureText(columnContent).width
    const title_w = context.measureText(title).width
    if (column_w < title_w) {
      columnContent = title || '留四个字'
    }
  }
  // 计算最宽内容的列宽
  const width = context.measureText(columnContent)
  _flexWidth = width.width + 40 + num
  return `${_flexWidth}px`
}

// 跳转维保商城地址
export function jumpShopAddress(next) {
  loginApi.purchaseMallLogIn({}).then((res) => {
    if (res && res.data) {
      newOpenPage(res.data, 'shop')
    } else {
      next()
    }
  }).finally(() => {
    next()
  })
}

export function newOpenPage(url, tag) {
  if (getBrowserType() === 'Firefox' || getBrowserType() === 'Safari') {
    setTimeout(() => {
      window.open(url, tag)
    })
  } else {
    const a = document.createElement('a')
    const id = 'newpage'
    a.setAttribute('href', url)
    a.setAttribute('target', tag)
    a.setAttribute('id', id)
    // 防止反复添加
    if (!document.getElementById(id)) {
      document.body.appendChild(a)
    }
    a.click()
  }
}
/**
* 字典转列表，用于select下拉列表等场景
* @param {*} obj  Object 原对象 JSON格式
* @param 第二个参数为选填 不填默认解析JSON的keys生成数组，对应value,label
*第二个参数支持两种情况
 1. Boolean值 默认会在JSON解析基础后数组，添加数组第一项，默认{value:'',label:'全部'}
 2. JSON对象 若第一项需要自定义，可直接传递对象进行解析，如{value:-1,label:'全部车辆'}
*/
export const dict2list = (obj, param2) => {
  const keys = Object.keys(obj)
  const arr = []
  for (let i = 0; i < keys.length; i++) {
    arr.push({
      value: parseInt(keys[i], 10),
      label: obj[keys[i]],
    })
  }

  if (param2) {
    const type = (typeof param2).toUpperCase()
    if (type === 'BOOLEAN') {
      arr.unshift({
        value: '',
        label: '全部',
      })
    } else if (param2 instanceof Object) {
      if (Object.keys(param2).length) {
        arr.unshift({
          value: param2.value,
          label: param2.label,
        })
      }
    }
  }
  return arr
}

/**
 * 判断一个值是否为空，除了0。
 *
 * 该函数旨在提供一个统一的方式来检查一个值是否应该被视为“空”。它特别处理了
 * undefined、空字符串、null以及字符串'null'这四种情况，因为这些值在逻辑上都表示为空，
 * 但在JavaScript中，它们与0、false等值的处理方式有所不同。
 *
 * @param {any} val - 需要检查的值，可以是任何类型。
 * @returns {boolean} - 如果值为空（除了0），则返回true；否则返回false。
 */
export const emptyExceptZero = (val) => {
  return val === undefined || val === '' || val === null || val === 'null'
}
/**
 * 获取浏览器类型
 * @returns {string} 浏览器类型
 */
export const getBrowserType = () => {
  const { userAgent } = navigator

  if (userAgent.indexOf('Firefox') > -1) {
    return 'Firefox'
  } else if (userAgent.indexOf('SamsungBrowser') > -1) {
    return 'Samsung Internet'
  } else if (userAgent.indexOf('Opera') > -1 || userAgent.indexOf('OPR') > -1) {
    return 'Opera'
  } else if (userAgent.indexOf('Trident') > -1) {
    return 'Internet Explorer'
  } else if (userAgent.indexOf('Edge') > -1) {
    return 'Microsoft Edge'
  } else if (userAgent.indexOf('Chrome') > -1) {
    return 'Chrome'
  } else if (userAgent.indexOf('Safari') > -1) {
    return 'Safari'
  } else {
    return 'Unknown'
  }
}

// 证件长期有效回显格式化
export const longDateFormat = (key, source) => {
  const { [key]: validDate } = source
  if (validDate === '2100-01-01') {
    return '长期有效'
  }
  return validDate || '-'
}

export const truncateToChar = (str, charToFind) => {
  const index = str.indexOf(charToFind)
  return index !== -1 ? str.substring(0, index) : str
}

export const validateArrayFields = (arr, fields) => {
  return arr.every((item) => {
    return fields.every((field) => {
      const value = item[field]
      // 检查值是否为null, undefined 或空字符串
      return value !== null && value !== undefined && value !== ''
    })
  })
}

// 点击菜单时或者页面刷新时，清空存储的页面的搜素条件
export const clearTableSearchParams = () => {
  // key值是以search_params结尾的，都清空
  Object.keys(sessionStorage).forEach((key) => {
    if (key.endsWith('_search_params')) {
      sessionStorage.removeItem(key)
    }
  })
}
